import { forwardRef } from 'react'
import { Input } from './input'

interface CpfInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const applyCpfMask = (value: string): string => {
  const numbers = value.replace(/\D/g, '').slice(0, 11)
  if (numbers.length <= 3) return numbers
  if (numbers.length <= 6) return `${numbers.slice(0, 3)}.${numbers.slice(3)}`
  if (numbers.length <= 9) return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6)}`
  return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6, 9)}-${numbers.slice(9)}`
}

export const CpfInput = forwardRef<HTMLInputElement, CpfInputProps>(
  ({ onChange, value, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const masked = applyCpfMask(e.target.value)
      const syntheticEvent = {
        ...e,
        target: { ...e.target, value: masked },
      } as React.ChangeEvent<HTMLInputElement>
      onChange?.(syntheticEvent)
    }

    const displayValue = typeof value === 'string' ? applyCpfMask(value) : value

    return (
      <Input
        ref={ref}
        type="text"
        inputMode="numeric"
        placeholder="000.000.000-00"
        maxLength={14}
        value={displayValue}
        onChange={handleChange}
        {...props}
      />
    )
  }
)

CpfInput.displayName = 'CpfInput'
